import { TabConfig } from '@customer-portal/shared';

import { SettingsTab } from '../models';

export const settingsTabs: TabConfig<SettingsTab>[] = [
  {
    id: SettingsTab.MyInformation,
    route: 'myInformation',
    label: 'navbar.myInformation',
    ariaLabel: 'navbar.myInformation',
  },
  {
    id: SettingsTab.Preferences,
    route: 'preferences',
    label: 'navbar.preferences',
    ariaLabel: 'navbar.preferences',
  },
  {
    id: SettingsTab.CompanyDetails,
    route: 'companyDetails',
    label: 'settings.tabs.companyDetails',
    ariaLabel: 'settings.tabs.companyDetails',
  },
  {
    id: SettingsTab.Sites,
    route: 'sites',
    label: 'navbar.sites',
    ariaLabel: 'navbar.sites',
  },
  {
    id: SettingsTab.Members,
    route: 'members',
    label: 'settings.tabs.members',
    ariaLabel: 'settings.tabs.members',
  },
];
